"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.btnPosition = exports.handleRenderItem = exports.handleRenderGroupSeparator = exports.renderBlank = void 0;
var react_1 = __importStar(require("react"));
var isType_1 = require("../___utils/isType");
var DefaultBlank_1 = __importDefault(require("./DefaultBlank"));
var renderBlank = function (renderWhenEmpty) {
    if (renderWhenEmpty === void 0) { renderWhenEmpty = null; }
    return renderWhenEmpty && (0, isType_1.isFunction)(renderWhenEmpty)
        ? renderWhenEmpty()
        : (0, DefaultBlank_1.default)();
};
exports.renderBlank = renderBlank;
var handleRenderGroupSeparator = function (CustomSeparator) {
    return function (sep, idx) {
        var cls = sep[0], groupLabel = sep[1], group = sep[2];
        var separatorKey = "separator-".concat(idx);
        if (CustomSeparator) {
            if ((0, isType_1.isFunction)(CustomSeparator)) {
                var Sep = CustomSeparator(group, idx, groupLabel);
                return (react_1.default.createElement("div", { key: separatorKey, className: cls },
                    react_1.default.createElement(Sep.type, __assign({}, Sep.props))));
            }
            return (react_1.default.createElement("div", { key: separatorKey, className: cls }, (0, react_1.cloneElement)(CustomSeparator, { groupLabel: groupLabel, group: group })));
        }
        return react_1.default.createElement("hr", { key: separatorKey, className: cls });
    };
};
exports.handleRenderGroupSeparator = handleRenderGroupSeparator;
var handleRenderItem = function (renderItem, renderSeparator) {
    if (renderSeparator === void 0) { renderSeparator = null; }
    return function (item, key) {
        if (!renderItem) {
            return null;
        }
        var itemId = item.id || key;
        if ((0, isType_1.isArray)(item) && item[0] === "___list-separator") {
            return renderSeparator
                ? renderSeparator(item, itemId)
                : null;
        }
        if ((0, isType_1.isFunction)(renderItem)) {
            return renderItem(item, itemId);
        }
        var comp = renderItem;
        return react_1.default.createElement(comp.type, __assign({}, comp.props, { key: itemId, item: item }));
    };
};
exports.handleRenderItem = handleRenderItem;
var btnPosition = function (scrollContainer, btn) {
    var z = window.getComputedStyle(scrollContainer).zIndex;
    btn.style.position = "absolute";
    btn.style.zIndex = "".concat(z === "auto" ? 1 : Number(z) + 1);
    btn.style.visibility = "hidden";
    return function (vertical, horizontal, padding, offset) {
        if (padding === void 0) { padding = 20; }
        if (offset === void 0) { offset = 50; }
        var x = "0px";
        var y = "0px";
        if (vertical === "top") {
            y = "".concat(parseFloat("".concat(padding)), "px");
        }
        else if (vertical === "bottom") {
            y = "calc(100% - ".concat(parseFloat("".concat(padding)) + btn.offsetHeight, "px)");
        }
        if (horizontal === "left") {
            x = "".concat(parseFloat("".concat(padding)), "px");
        }
        else if (horizontal === "right") {
            x = "calc(100% - ".concat(parseFloat("".concat(padding)) + btn.offsetWidth, "px)");
        }
        window.requestAnimationFrame(function () {
            var dist = Number((scrollContainer.scrollHeight - scrollContainer.offsetHeight).toFixed(0));
            offset = Math.min(offset, dist);
            btn.style.top = y;
            btn.style.left = x;
            btn.style.visibility =
                dist !== 0 && // got scrolled
                    Number(scrollContainer.scrollTop.toFixed(0)) >= offset // position meets the offset
                    ? "visible"
                    : "hidden";
        });
    };
};
exports.btnPosition = btnPosition;
//# sourceMappingURL=uiFunctions.js.map